'use strict';
/**
 * @description Initialize event handlers on landing page
 */

window.addEventListener('mainJsLoaded', function (event) {
    collectionInit();
});

function collectionInit() {
    var $catalogTilesContainer = $('.catalog-tiles-container'),
        $landingCarousel = $('#landing-tab-carousel'),
        $looksCarousel = $('#js-looksCarousel'),
        $materials = $('#js-materials');

    // carousel init on image load
    if ($landingCarousel.length) {
        $landingCarousel.find('img').first().one('load', function () {
            if (window.vbqUtils.breakpoint.is('fromDesktop')) {
                $landingCarousel.slick({
                    slidesToShow: 1,
                    dots: false,
                    arrows: true,
                    swipe: true,
                    adaptiveHeight: true
                });
            }
            else {
                $landingCarousel.slick({
                    slidesToShow: 1,
                    dots: true,
                    arrows: false,
                    swipe: true,
                    adaptiveHeight: true
                });
            }
        });
    }

    // carousel re-init on media query change only!
    window.vbqUtils.breakpoint.set([
        {
            media: window.vbqUtils.breakpoint.getMediaQuery('mobileAndTablet'),
            enter: function () {
                $landingCarousel.slick({
                    slidesToShow: 1,
                    dots: true,
                    arrows: false,
                    swipe: true,
                    adaptiveHeight: true
                });
            }
        },
        {
            media: window.vbqUtils.breakpoint.getMediaQuery('fromDesktop'),
            enter: function () {
                $landingCarousel.slick({
                    slidesToShow: 1,
                    dots: false,
                    arrows: true,
                    swipe: true,
                    adaptiveHeight: true
                });
            }
        }
    ], true); // on media query change only

    window.vbqUtils.breakpoint.set([
        {
            media: window.vbqUtils.breakpoint.getMediaQuery('mobileAndTablet'),
            enter: function () {
                if ($materials.length) {
                    if ($materials.hasClass('slick-initialized')) {
                        $materials.slick('unslick');
                    }

                    $materials.slick({
                        slidesToShow: 1,
                        variableWidth: false,
                        adaptiveHeight: false,
                        centerMode: true,
                        centerPadding: '30px',
                        dots: true,
                        arrows: false,
                        swipe: true
                    });
                }
            }
        },
        {
            media: window.vbqUtils.breakpoint.getMediaQuery('fromDesktop'),
            enter: function () {
                if ($materials.length) {
                    if ($materials.hasClass('slick-initialized')) {
                        $materials.slick('unslick');
                    }

                    $materials.slick({
                        slidesToShow: 1,
                        adaptiveHeight: true,
                        dots: false,
                        arrows: true,
                        swipe: false,
                        fade: true,
                        infinite: true,
                        speed: 1500,
                        appendArrows: '#js-materialsArrows'
                    });

                    // force a refresh after the image is loaded so the arrows are correctly positionned
                    $materials.find('.js-materialsImage').first().one('load', function () {
                        $materials[0].slick.refresh();
                    });
                }
            }
        }
    ]);

    // Initialize product carousel
    window.vbqUtils.carousel.init();

    var setLooksCarousel = function () {
        if ($looksCarousel.length) {
            if ($looksCarousel.hasClass('slick-initialized')) {
                $looksCarousel.slick('unslick');
            }

            var isMobile = window.vbqUtils.breakpoint.is('mobile'),
                isTablet = window.vbqUtils.breakpoint.is('tablet'),
                slidesToShow = isMobile ? 2 : (isTablet ? 3 : 4);

            $looksCarousel.slick({
                slidesToShow: slidesToShow,
                rows: isMobile ? 2 : 1,
                dots: isMobile || isTablet,
                arrows: !isMobile && !isTablet,
                swipe: true,
                mobileFirst: true,
                adaptiveHeight: true
            });
        }
    };

    $('.category-tile-background.forced').on('load', function () {
        if ($catalogTilesContainer.length) {
            if (window.vbqUtils.breakpoint.is('tabletAndDesktop')) {
                calculateTileSize();

                $catalogTilesContainer = $catalogTilesContainer.masonry({
                    columnWidth: '.catalog-grid-sizer',
                    itemSelector: '.catalog-category-tile'
                });
                $catalogTilesContainer.addClass('masonry-initialized');
            }
            else {
                $catalogTilesContainer.filter('.masonry-initialized').masonry('destroy');
                $catalogTilesContainer.removeClass('masonry-initialized');
            }

            $catalogTilesContainer.addClass('visible');
        }
    });

    window.vbqUtils.cache.$window.resize(window.vbqUtils._debounce(function () {
        setLooksCarousel();

        if (window.vbqUtils.breakpoint.is('tabletAndDesktop')) {
            calculateTileSize();

            if ($catalogTilesContainer.length) {
                $catalogTilesContainer.masonry();
                $catalogTilesContainer.addClass('masonry-initialized');

                if (!$catalogTilesContainer.hasClass('visible')) {
                    $catalogTilesContainer.addClass('visible');
                }
            }
        }
        else {
            $catalogTilesContainer.filter('.masonry-initialized').masonry('destroy');
            $catalogTilesContainer.removeClass('masonry-initialized');
        }
    }, 200));

    setLooksCarousel();
}

function calculateTileSize() {
    var $catalogTilesContainer = $('.catalog-tiles-container'),
        $tiles = $('.catalog-category-tile'),
        widthMultiplier,
        heightMultiplier,
        layoutSplit,
        currentUnit = $catalogTilesContainer.width() / 4,
        $value;

    $tiles.each(function (key, value) {
        $value = $(value);

        if ($value.attr('data-layout')) {
            layoutSplit = $value.attr('data-layout').split('x');
        }

        if (layoutSplit && layoutSplit.length == 2) {
            widthMultiplier = layoutSplit[0];
            heightMultiplier = layoutSplit[1];
            $value.width(Math.ceil(currentUnit * widthMultiplier));
            $value.height(Math.ceil(currentUnit * heightMultiplier));
        }
    });
}
